module.exports = __webpack_public_path__ + "img/network-error.1a383874.png";